import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { settingService } from "../../../services/extensions";
import { InputText } from "primereact/inputtext";
import { Util } from "../../../services";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import AddAbsenceCodeForm from "./absenceCode-form";
import { confirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";
import ImportPopup from "../importpopup/importPop";
import { useRef } from "react";

function AbsenceCode({}) {
  const [absenceCode, setAbsenceCode] = useState([]);
  const [absenceCodeDialog, setAbsenceCodeDialog] = useState(false);
  const [importDialog, setImportDialog] = useState(false);
  const dt = useRef(null);
  const [selectedAbsenceCode, setSelectedAbsenceCode] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [SelectLocation, setSelectLocation] = useState([]);
  const [MasterLocation, setMasterLocation] = useState([]);
  const [legalEntities, setLegalEntities] = useState(null);


  useEffect(() => {
    getAllAbsenceCodes();
  }, []);

  useEffect(() => {
    getLegalEntity();
  }, []);

  const getLegalEntity = () => {
    settingService.getLegalEntity().then((resp) => {
      setLegalEntities(resp.data.data);
    });
  };

  const getAllAbsenceCodes = () => {
    settingService.getAllAbsenceCodesForAdmin().then((resp) => {
      setAbsenceCode(resp.data.data);
    });
  };
  const filterLocation = (data, Location) => {
    setSelectLocation(data);
    let locationFilter = Location.filter((item) => {
      return item.Location === data.Location;
    });
    setMasterLocation(locationFilter);
  };
  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
    if (status === 2) return "REJECT";
    if (status === 3) return "UPCOMING";
    if (status === 4) return "ARCHIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
    if (status === 2) return "red";
    if (status === 3) return "#cb7205";
    if (status === 4) return "rgb(222 204 90)";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  };

  const addAbsenceCode = () => {
    setAbsenceCodeDialog(true);
  };

  const onHide = () => {
    setAbsenceCodeDialog(false);
  };

  const closeAbsenceCodeDialog = () => {
    setAbsenceCodeDialog(false);
    getAllAbsenceCodes();
  };

  const NewAbsenceCodeDialog = () => {
    return (
      <Dialog
        style={{ width: "30vw" }}
        header="Add Absence Code"
        visible={absenceCodeDialog}
        onHide={() => onHide()}>
        <AddAbsenceCodeForm       
          onClose={(e) => {
            closeAbsenceCodeDialog();
          }} />
      </Dialog>
    );
  };

  const onClickDeallocation = (rowData) => {
    setImportDialog(true);
  }
  const onHideImport = () => {
    setImportDialog(false);
  };

  const OpenimportDialog = () => {
    return (
      <Dialog className="pop-up-dialog" header="Import" footer={<Button label="Submit"></Button>} visible={importDialog} onHide={() => onHideImport()}>
        <ImportPopup
          onClose={(e) => {
            setImportDialog(false);
          }}
          type="absenceCode" />
      </Dialog>
    );
  };

  const exportExcel = () => {
    Util.exportExcel(absenceCode, "absenceCode");
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const cols = [
    { field: "id", header: "Id" },
    { field: "code", header: "Code" },
    { field: "title", header: "Title" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportPdf = () => {
    Util.exportAsPdf(exportColumns, absenceCode, "Absence_Code");
  };

  const items = [
    {
      label: "CSV",
      icon: "pi pi-file-export",
      command: () => {
        exportCSV();
      },
    },
    {
      label: "EXCEL",
      icon: "pi pi-file-excel",
      command: () => {
        exportExcel();
      },
    },
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPdf();
      },
    },
  ];

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button mr-2"
          onClick={() => addAbsenceCode()}
        ></Button>
        <Button
          type="button"
          label="Delete"
          icon="pi pi-trash"
          className="p-button-danger"
          disabled={disabled}
          onClick={deleteConfirm}
        ></Button>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Import"
          icon="pi pi-plus"
          className="mr-2"
          onClick={() => {
            onClickDeallocation();
          }} />
        <SplitButton
          label="Export"
          icon="pi pi-download"
          className="p-button-info"
          model={items}
          appendTo="self" />
      </React.Fragment>
    );
  };

  const editRowComplete = (e) => {
    let _absenceCode = [...absenceCode];
    let { newData, index } = e;
    _absenceCode[index] = newData;
    let param = {
      id: _absenceCode[index].id,
      code: _absenceCode[index].code,
      title: _absenceCode[index].title,
      status: _absenceCode[index].status,
      locationID: _absenceCode[index].locationID
    };
    try {
      settingService.updateLeaveAbsenceCode(param).then(
        (resp) => {
          if (resp) {
            toast.success("Absence code updated successfully!");
            getAllAbsenceCodes();
          }
        },
        (err) => {
          toast.error("Unable to update absence code");
        }
      );
    } catch (error) {
      toast.error("Unable to update absence code");
    }
  };

  const deleteAbsenceCode = (e, row) => {
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        settingService.deleteAbsenceCodeById(row.id).then(
          (resp) => {
            toast.success("Absence Code deleted successfully!");
            getAllAbsenceCodes();
          },
          (error) => { }
        );
      },
      accept: () => { },
    });
  };

  const deleteAbsenceCodeByRow = (row) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={(e) => deleteAbsenceCode(e, row)}
        ></Button>
      </React.Fragment>
    );
  };

  const codeEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.toUpperCase())}></InputText>
    );
  };

  const titleEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))}></InputText>
    );
  };

  const commentEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))}></InputText>
    );
  };

  const statuses = [
    { label: "INACTIVE", value: 0 },
    { label: "ACTIVE", value: 1 },
    { label: "ARCHIVE", value: 4 },
  ];

  const statusEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select a Status"
        // itemTemplate={(option) => {
        //   return (
        //     <span className={`product-badge status-${option.label.toLowerCase()}`}>{option.label}</span>
        //   );
        // }}
      />
    );
  };

  const Locations = [
    { value: 1, label: "AUS" },
    { value: 2, label: "CAN" },
    { value: 3, label: "IND" },
    { value: 4, label: "SIN" },
    { value: 5, label: "UK" },
    { value: 6, label: "USA" },
    { value: 7, label: "PHL" },
  ]

  const locationEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={Locations}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select a Location"
      />
    );
  }

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const deleteConfirm = () => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptFunc(),
      reject,
    });
  };

  const acceptFunc = () => {
    var absenceCodeIdList = [];
    selectedAbsenceCode.map((item, value) => {
      absenceCodeIdList[value] = item.id;
    });
    let param = {
      Ids: absenceCodeIdList,
    };
    try {
      settingService.deleteMultipleAbsenceCodes(param).then(
        (resp) => {
          toast.success("Absence Codes deleted");
          setSelectedAbsenceCode([]);
          getAllAbsenceCodes();
        },
        (err) => {
          toast.error(err.response.data.error);
          setSelectedAbsenceCode([]);
        }
      );
    } catch (error) {
      toast.error("Unable to delete Absence Code");
    }
  };

  const onCheckAbsenceCode = (e) => {
    setSelectedAbsenceCode(e.value);
    if (e.value.length > 0) {
      setDisabled(false);
    }
  };

  const locationBodyTemplate = (absenceCode) => {
    return <p>{absenceCode?.legalEntity?.code}</p>
  }
  const rightDropdownTemplate = () => {
    return (
      <React.Fragment>
        <div className="mt-3 mr-3">
          <h3>Select Location</h3>
        </div>
        <Dropdown
          filter
          style={{ width: "250px" }}
          placeholder="Select Location"
          optionLabel="code"
          options={legalEntities}
          value={SelectLocation}
          // onChange={(e) => filterLocation(e.value, Locations)}
          appendTo="self"
        ></Dropdown>
      </React.Fragment>
    );
  };

  return (
    <div>
      <Toolbar
        className="mb-2"
        left={leftToolbarTemplate}
        right={rightToolbarTemplate}
        
      ></Toolbar>
      <div>
        <Toolbar
          className="mb-2"
          left=""
          right={rightDropdownTemplate}
        ></Toolbar>
      </div>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={absenceCode}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            editMode="row"
            onRowEditComplete={editRowComplete}
            ref={dt}
            selectionMode="checkbox"
            selection={selectedAbsenceCode}
            onSelectionChange={(e) => onCheckAbsenceCode(e)}>
            <Column selectionMode="multiple" headerStyle={{ width: "4rem" }}></Column>
            <Column field="code" header="Code" headerStyle={{ width: "8rem" }} sortable editor={(options) => codeEditor(options)}></Column>
            <Column field="title" header="Title" headerStyle={{ width: "8rem" }} sortable editor={(options) => titleEditor(options)}></Column>
            <Column field ="locationID" header="Location" headerStyle={{ width: "8rem" }} style={{ width: "20%" }} body={locationBodyTemplate} editor={(options) => locationEditor(options)}></Column>
            <Column field="status" header="Status" headerStyle={{ width: "8rem" }} body={statusBodyTemplate} editor={(options) => statusEditor(options)} style={{ width: "20%" }}></Column>
            {/* <Column field="comments" header="Comments" headerStyle={{ width: "8rem" }} sortable editor={(options) => commentEditor(options)}></Column> */}
            <Column rowEditor headerStyle={{ width: "10%", minWidth: "8rem" }} bodyStyle={{ textAlign: "right" }}></Column>
            <Column rowEditor style={{ minWidth: "8rem" }} exportable={false} body={deleteAbsenceCodeByRow} headerStyle={{ width: "10%", minWidth: "8rem" }}></Column>
          </DataTable>
        </div>
      </div>
      {OpenimportDialog()}
      {NewAbsenceCodeDialog()}
    </div>
  );
}

export default AbsenceCode;